// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DarkmodeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DarkmodeIcon" ref={forwardedRef} {...props}>
      <path d="M3 9.03A7.97 7.97 0 0 1 7.214 2l.003.004 1.457.323c-.838 3.776-.02 6.383 1.582 7.854 1.614 1.483 4.223 1.999 7.353 1.156L18 12.783h-.002L18 12.786A7.97 7.97 0 0 1 3 9.03m12.943 4.142c-2.643.282-5.018-.343-6.7-1.888C7.48 9.664 6.614 7.159 6.897 4a6.472 6.472 0 1 0 9.046 9.172" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DarkmodeIcon = /* @__PURE__ */ Object.assign(
  DarkmodeIconComponent,
  { displayName: 'DarkmodeIcon' },
);
